export default {
  button: {
    schedule: "Nu inplannen",
    scheduling: "Verwerken...",
    login: "Inloggen",
    premium: "Bekijk Apostle Premium",
    premium_small: "Apostle Premium"
  },
  langhint: {
    nl: "De huidige taal is ingesteld op Nederlands",
    en: "Engels instellen als taal"
  },
  wall: {
    title: "Inspiration wall",
    summary:
      "Hieronder zie je berichten die al gedeeld zijn met Apostle Connect",
    readmore: "Meer lezen"
  },
  form: {
    post: {
      label: "Inhoud van je bericht",
      placeholder: "Schrijf je eigen bericht",
      error: "Dit veld mag niet leeg zijn"
    },
    receivers: {
      label:
        "De e-mail adressen van je collega's die je bericht ontvangen (max. 10)",
      placeholder: "E-mail adres...",
      error: {
        empty: "Vul minimaal 1 adres in",
        maximum: "Je mag niet meer dan 10 adressen invoeren"
      }
    },
    name: {
      label: "Je voornaam",
      placeholder: "Voornaam",
      error: "Dit veld mag niet leeg zijn"
    },
    email: {
      label: "Je e-mail adres (wordt aan de lijst toegevoegd)",
      placeholder: "E-mail adres",
      error: {
        empty: "Dit veld mag niet leeg zijn",
        listed: "Dit e-mail adres staat al in de lijst",
        invalid: "Dit e-mail adres is niet geldig",
        company: "Je kunt alleen een zakelijk e-mail adres gebruiken"
      }
    },
    text: {
      more: "Wil je met meer dan 10 collega's berichten delen?",
      link: "Probeer dan nu Apostle Connect uit!",
      done: {
        title: "Dat was het!",
        text: {
          line_one:
            "Je collega's zullen nu een e-mail ontvangen met uitleg over wat ze nu moeten doen",
          line_two:
            "Ze zullen het bericht op een makkelijke manier kunnen delen op sociale media kanalen naar keuze.",
          line_three: "Wil je meer informatie over onze software?"
        },
        link: "Voor meer informatie en contact kun je hier terecht"
      }
    },
    api: {
      error: {
        first: "Er heeft zich een fout voorgedaan, probeer het nogmaals!",
        multiple:
          "Er gaat nog steeds iets mis...\r\nJe zou contact op kunnen nemen met onze technische ondersteuning."
      }
    }
  }
};
